<script lang="ts" setup>
import type { IAppProps } from '@/interfaces/IAppProps'
import { loadingController } from '@nami/apis'
import { onMounted, toRefs } from 'vue'
import { callFlutterApi } from '@/apis/FlutterApi'
import { mainToggleApi } from '@/apis/mainToggleApi'
import { useEntryProps } from '@/composable/useDatasetProps'
import { useGlobalStore } from '@/stores/globalStore'
import { useUserStore } from '@/stores/userStore'
import GtmScript from './components/gtm/GtmScript.vue'
import Footer from './components/layout/Footer.vue'
import Header from './components/layout/Header.vue'
import Loading from './components/layout/Loading.vue'
import MainContent from './components/layout/MainContent.vue'
import MetaScript from './components/meta/MetaScript.vue'

const appProps = useEntryProps<IAppProps>()
const globalStore = useGlobalStore()
globalStore.setAppProps(appProps)
const userStore = useUserStore()
const { isUserInfoReady } = toRefs(userStore)

if (appProps.isApp) {
    localStorage.setItem('Device', 'app')
}
else {
    localStorage.setItem('Device', 'web')
}

const autoReloadMainToggle = async () => {
    await mainToggleApi.get()
    setInterval(async () => {
        await mainToggleApi.get()
    }, 60000)
}

onMounted(() => {
    // check and delete duplicate lang cookie from Akis like domain is 'account.<sbo domain>.com'
    document.cookie = `lang=; Path=/; Expires=${new Date().toUTCString()}`
    autoReloadMainToggle()
    callFlutterApi({
        action: 'page_load_finished',
    })
})
</script>

<template>
    <MetaScript />
    <GtmScript />
    <Header v-show="!appProps.isApp" v-if="isUserInfoReady" />
    <MainContent v-if="isUserInfoReady" :class="globalStore.appProps.isApp ? 'main-content-app' : ''" />
    <Footer v-show="!appProps.isApp" />
    <Loading v-if="globalStore.requestStack.length > 0 || globalStore.requestStack.length > 0 || loadingController.isLoading.value" />
</template>

<style lang="scss">
@use "./assets/styles/all" as *;

.main-content-app {
    min-height: 100vh;
}
</style>
